import React from 'react';
import ArticleSideBar from '../Components/ArticleSideBar.js';
import EditPage from '../Components/EditPage.js';
import Header from '../Components/Heading.js';

export default function CreatePage() {
	return (
		<div className="grid">
			<div className="flex">
				<aside className="h-screen sticky top-0 mr-3 pr-2 border-r-2  w-1/4 ">
					<br />
					<br />
					<br />
					<br />
					<br />
			
						<ArticleSideBar
							type="CREATE"

							isPage={true}
						/>
		
				</aside>
				<main className="w-3/4">
					<Header text="Create Page" type="h1" />
					<EditPage type="CREATE" />
				</main>
			</div>
		</div>
	);
}
